<ion-header [translucent]="true">
	<ion-toolbar color="primary" mode="md">
		<ion-buttons slot="start">
			<ion-button (click)="openMenu()" auto-hide="false">
				<ion-icon name="menu-outline" size="large"></ion-icon>
			</ion-button>
		</ion-buttons>
		<ion-buttons slot="primary">
			<app-sync-button></app-sync-button>
			<!-- <ion-button (click)="openMenu('main-options')" auto-hide="false">
				<ion-icon
					slot="icon-only"
					ios="ellipsis-horizontal"
					md="ellipsis-vertical"
				></ion-icon>
			</ion-button> -->
		</ion-buttons>
		<ion-title>{{ pageTitle }}</ion-title>
	</ion-toolbar>
</ion-header>

<!-- Menu -->
<ion-menu side="start" [menuId]="mainMenuId" contentId="main-content">
	<ion-header>
		<ion-toolbar>
			<ion-title>
				Menu
			</ion-title>
		</ion-toolbar>
	</ion-header>
	<ion-content>
		<ion-item-divider>
			<ion-label>
				Navigation
			</ion-label>
		</ion-item-divider>
		<ion-list lines="full">
			<ion-item
				*ngFor="let route of routes"
				button
				(click)="navigateTo(route.url)"
				[color]="currentRoute === route.url ? 'primary' : ''"
			>
				<ion-icon slot="start" [name]="route.icon"></ion-icon>
				<ion-text>{{ route.text }}</ion-text>
			</ion-item>
		</ion-list>
		<ion-item-divider>
			<ion-label>
				Options
			</ion-label>
		</ion-item-divider>
		<ion-list lines="full">
			<!-- Reload Configuration -->
			<ion-item
				button
				(click)="reloadConfiguration()"
				[hidden]="!(isOnline$ | async)"
			>
				<ion-icon
					slot="start"
					name="download-outline"
					class="sync-icon"
				></ion-icon>
				<ion-text>Reload Configuration</ion-text>
			</ion-item>
			<ion-item
				button
				(click)="alertOffline()"
				[hidden]="isOnline$ | async"
			>
				<ion-icon
					slot="start"
					name="sync-outline"
					class="sync-icon offline"
				></ion-icon>
				<ion-text>Reload Configuration</ion-text>
			</ion-item>
			<!-- <ion-item button>
				<ion-icon
					slot="start"
					name="information-circle-outline"
				></ion-icon>
				<ion-text>About</ion-text>
			</ion-item> -->
			<ion-item button (click)="logout()">
				<ion-icon slot="start" name="log-out-outline"></ion-icon>
				<ion-text>Log Out</ion-text>
			</ion-item>
		</ion-list>
	</ion-content>
</ion-menu>
